'use strict';
var parent = require('../../es/map');
require('../../modules/web.dom-collections.iterator');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/stable/map/index.js
// module id = 1555
// module chunks = 0